<template>
  <page-section :title="$t('Integrations_Overview_Information')">
    <form-section>
      <b>{{ $t('Integrations_Field_WebhookUrl') }}</b>
      : {{ model.params.url }}
    </form-section>
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import FormSection from '@/common/components/form/FormSection'
export default {
  name: 'OpapWebhookOverview',
  components: { FormSection, PageSection },
  props: {
    model: {
      required: false
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/opapwebhook/OpapWebhookOverview.vue